import { throwApiError } from '@/shared/utils/apiResponse';
import { apiDelete, apiGet, apiPut } from '@/shared/utils/requestBuilder';

import type { FeedbackTipo } from '../types/negociacaoFeedbackTypes';

const unwrapBody = async <T>(response: Response): Promise<T> => {
  const body = (await response.json()) as unknown;
  const payload = (body as { data?: unknown })?.data ?? body;
  return payload as T;
};

export const negociacaoFeedbackService = {
  getMinhaAvaliacao: async (
    conversaId: string,
  ): Promise<{ tipo: FeedbackTipo | null; justificativa: string | null }> => {
    const response = await apiGet(`/negociacao/${conversaId}/minha-avaliacao`);
    if (!response.ok) {
      await throwApiError(response, 'Erro ao carregar avaliação');
    }
    return unwrapBody<{ tipo: FeedbackTipo | null; justificativa: string | null }>(response);
  },

  registrar: async (
    conversaId: string,
    tipo: FeedbackTipo,
    justificativa: string | null,
  ): Promise<{ tipo: FeedbackTipo; justificativa: string | null }> => {
    const body: { tipo: FeedbackTipo; justificativa?: string } = { tipo };
    if (justificativa) body.justificativa = justificativa;
    const response = await apiPut(`/negociacao/${conversaId}/avaliacao`, body);
    if (!response.ok) {
      await throwApiError(response, 'Erro ao registrar feedback');
    }
    return unwrapBody<{ tipo: FeedbackTipo; justificativa: string | null }>(response);
  },

  remover: async (conversaId: string): Promise<void> => {
    const response = await apiDelete(`/negociacao/${conversaId}/avaliacao`);
    if (!response.ok) {
      await throwApiError(response, 'Erro ao remover feedback');
    }
  },
};
